import { render, staticRenderFns } from "./MobileFeatures.vue?vue&type=template&id=0c3379be&scoped=true&"
import script from "./MobileFeatures.vue?vue&type=script&lang=js&"
export * from "./MobileFeatures.vue?vue&type=script&lang=js&"
import style0 from "../MobilePage.scss?vue&type=style&index=0&id=0c3379be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3379be",
  null
  
)

export default component.exports